<template>
  <v-dialog v-model="value" width="850" persistent>
    <v-card>

      <v-card-title>Edit Ticket</v-card-title>

      <v-card-text>

        <v-row>

          <v-col cols="12" md="6">
            <v-row>
              <v-col>
                <v-autocomplete label="Agent" v-model="agent" :items="getCrmUsersForSelect" dense hide-details outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select label="Department" v-model="team" :items="getTicketTeams" dense hide-details outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete label="Escalation Agent" v-model="escalation_agent" :items="getCrmUsersForSelect" dense hide-details outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field label="Callback Number" v-model="callback_number" dense hide-details outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <DateTimePicker label="Next follow up date" ref="dateTimePicker" :pdt="next_follow_up_date" @set-datetime="setDatetime" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field label="Supplier Ticket ID" v-model="supplier_ticket_id" dense outlined :hide-details="!$v.supplier_ticket_id.$invalid" :error-messages="supplierIdErrors" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" @blur="$v.supplier_ticket_id.$touch()" @input="$v.supplier_ticket_id.$touch()"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6">
            <v-row>
              <v-col>
                <v-select v-model="cause" label="Cause" :items="getTicketCauses" hide-details :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" dense outlined></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-textarea v-model="cause_summary" label="Cause Summary" counter="200" hide-details="auto" :error-messages="causeSummaryErrors" @input="$v.cause_summary.$touch()" @blur="$v.cause_summary.$touch()" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" dense outlined ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-textarea v-model="root_cause_analysis" label="Root cause analysis" counter="200" hide-details="auto" :error-messages="rootCauseErrors" @input="$v.root_cause_analysis.$touch()" @blur="$v.root_cause_analysis.$touch()" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" dense outlined ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-textarea v-model="outcome" label="Outcome" counter="200" hide-details="auto" :error-messages="outcomeErrors" @input="$v.outcome.$touch()" @blur="$v.outcome.$touch()" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" dense outlined></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="ticketUpdateLoading" :loading="ticketUpdateLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="ticketUpdateLoading">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { maxLength } from "vuelidate/lib/validators";
  import moment from 'moment';
  import { formatDateToUTC } from '@/helpers';

  import DateTimePicker from '@/components/Globals/DateTimePicker';
  
  export default {

    components: {DateTimePicker},

    props: ['value'],

    validations: {
      supplier_ticket_id: { maxLength: maxLength(256) },
      cause_summary: { maxLength: maxLength(200) },
      root_cause_analysis: { maxLength: maxLength(200) },
      outcome: { maxLength: maxLength(200) }
    },

    data() {
      return {
        agent: '',
        team: '',
        escalation_agent: '',
        callback_number: '',
        next_follow_up_date: null,
        todaysDate: moment(new Date()).format('YYYY-MM-DD'),
        supplier_ticket_id: null,
        cause: '',
        cause_summary: '',
        root_cause_analysis: '',
        outcome: ''
      }
    },

    watch: {
      async value(open) {
        if(open){
          await this.fetchCRMUsers();
          this.agent = this.currentTicket.agent;
          this.team = this.currentTicket.team;
          this.escalation_agent = this.currentTicket.escalation_agent;
          this.callback_number = this.currentTicket.callback_number;
          this.next_follow_up_date = this.currentTicket.next_follow_up_date!==null?this.$options.filters.formatDate(this.currentTicket.next_follow_up_date, 'yyyy-MM-DD HH:mm'):null;
          this.supplier_ticket_id = this.currentTicket.supplier_ticket_id;
          this.cause = this.currentTicket.cause;
          this.cause_summary = this.currentTicket.cause_summary;
          this.root_cause_analysis = this.currentTicket.root_cause_analysis;
          this.outcome = this.currentTicket.outcome;
        }
      }
    },

    computed: {

      ...mapGetters('crmUsers',['getCrmUsersForSelect']),
      ...mapState('crmUsers',['crmUsersLoading']),
      ...mapState('tickets',['currentTicket','ticketUpdateLoading']),
      ...mapGetters('tickets',['getTicketTeams', 'getTicketCauses']),

      supplierIdErrors() {
        const errors = [];
        if (!this.$v.supplier_ticket_id.$dirty) return errors;
        !this.$v.supplier_ticket_id.maxLength && errors.push("Maximum character length of supplier id field is 256");
        return errors;
      },

      causeSummaryErrors() {
        const errors = [];
        if (!this.$v.cause_summary.$dirty) return errors;
        !this.$v.cause_summary.maxLength && errors.push('Max 200 characters');
        return errors;
      },

      rootCauseErrors() {
        const errors = [];
        if (!this.$v.root_cause_analysis.$dirty) return errors;
        !this.$v.root_cause_analysis.maxLength && errors.push('Max 200 characters');
        return errors;
      },

      outcomeErrors() {
        const errors = [];
        if (!this.$v.outcome.$dirty) return errors;
        !this.$v.outcome.maxLength && errors.push('Max 200 characters');
        return errors;
      }

    },

    methods: {

      ...mapActions('crmUsers',['fetchCRMUsers']),
      ...mapActions('tickets',['updateTicketData','fetchTicketByID']),

      setDatetime(datetime){
        this.next_follow_up_date = datetime;
      },

      async submit(){
        this.$v.$touch();
        if(!this.$v.$invalid) {
          const id = this.$route.params.id;
          const data = {
            agent: this.agent,
            team: this.team,
            escalation_agent: this.escalation_agent,
            callback_number: this.callback_number,
            next_follow_up_date: this.next_follow_up_date!==null?formatDateToUTC(this.next_follow_up_date):null,
            supplier_ticket_id: this.supplier_ticket_id,
            cause: this.cause,
            cause_summary: this.cause_summary,
            root_cause_analysis: this.root_cause_analysis,
            outcome: this.outcome
          }
          const success = await this.updateTicketData({id:id,data});
          if(success){
            this.close();
            this.fetchTicketByID(id);
          }
        }
      },

      reset() {
        this.next_follow_up_date = null;
        this.$refs.dateTimePicker.resetDateTimePicker();
      },
      
      close() {
        this.reset();
        this.$emit('input',false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
